import { ca } from '@cian/analytics';

export const trackHeadCategoryClick = (block: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'Click',
    label: 'top_categories',
    page: {
      extra: {
        block,
      },
    },
  });
};
